import { useState } from "react";
import { useLoaderData } from "react-router-dom";
import Button from "../components/Button";
import Dropdown from "../components/Dropdown";
import { usHttp2 } from "../custom-hooks/use-http";
import appvariables from "../appvariables";
import { loadingsliceactions } from "../store/loading-slice";
import { useDispatch } from "react-redux";
import Table from "../components/Table";

const CreditStory = () => {
    const { villages } = useLoaderData();
    const [selectedVillage, setSelectedVillage] = useState('');
    const [details, setDetails] = useState([]);

    const masterdispatcher = useDispatch();

    const villagechangehandler = (e) => {
        setSelectedVillage(e.target.value);
    }

    const GetCreditStory = () => {
        masterdispatcher(loadingsliceactions.updateloading({state: 'loading'}));
        if(selectedVillage !== '')
        {
            usHttp2(appvariables.apiurl + 'bill/creditstory/', 'POST', { selectedVillage: selectedVillage })
            .then((response) => response.json())
            .then((json) => {
                masterdispatcher(loadingsliceactions.updateloading({state: ''}));
                setDetails(json['details']);
            });
        }
    }

    const PhoneLink = (phonenumber) => {
        return <> 
            {phonenumber}&nbsp;&nbsp;
            <Button cs={{
                backgroundColor: "black",
                color: "aliceblue",
                borderRadius: "20px",
                fontWeight: "300",
                textDecoration: "none",
                padding: "5px 15px",
                fontSize: "15px",
            }}>
                <a style={{textDecoration: 'none', color: 'white'}} href={"tel:+91"+phonenumber} >
                    Call
                </a>
            </Button>
        </>
    }

    const tablefields = [
        {'name': 'Name' , 'key': 'name', cs:{ width: '220px' }},
        {'name':'Credit', 'key': 'credit', cs:{ width: '80px' }},
        {'name':'Phone', 'key': 'pn', transformer: PhoneLink , cs:{ width: '150px' }}
    ];

    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems:'center'}}>
            <h1>Credit Story</h1>
            <div style={{display: 'flex', alignItems: 'center', gap: '100px'}} >
                <Dropdown dropdownstyle={'compact'} id={'createbillvill'} name={'createbillvill'} displayname={'Village'} changehandler={villagechangehandler} options={villages} />
                <Button disabled={selectedVillage.length === 0} clickhandler={GetCreditStory} cs={{backgroundColor:selectedVillage.length === 0 && 'rgba(0,0,0,0.6)', borderColor: selectedVillage.length === 0 && 'rgba(0,0,0,0.6)'}}>Get Story</Button>
            </div>
            <Table data={details} tablefields={tablefields} />
            <h3>Credit In the village: {details.reduce((acc, cur) => acc + cur['credit'], 0)}</h3>
        </div>
    )
}

export default CreditStory;